const onInit = (fn) => {
  document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn)
      : fn();
};

export default onInit;
